import api from "../api";
import { LOGGER_USER_ACTIVITY, LOGGER_APP_ERROR } from "../../constants";

//NOT USED ANYMORE
class Analytics {
  constructor() {
    const userInfo = null; // auth.getUserInfo();
    if (userInfo !== null) {
      this.user = btoa(userInfo.email);
    } else {
      this.user = "";
    }
  }

  _sendData(logger, data) {
    data.visibilityState = document.visibilityState; //all browsers may not support it https://www.w3.org/TR/page-visibility/

    api
      .frontendUtils()
      .saveUserLog(this.user, logger, data)
      .subscribe(
        () => {},
        error => {
          console.error(error);
        }
      );
  }

  event(component, action, data) {
    data = {
      client_date: new Date().getTime(),
      component,
      action,
      ...data
    };

    this._sendData(LOGGER_USER_ACTIVITY, data);
  }

  error(component, action, data) {
    data = {
      client_date: new Date().getTime(),
      component,
      action,
      ...data
    };

    this._sendData(LOGGER_APP_ERROR, data);
  }
}

export default new Analytics();



// WEBPACK FOOTER //
// ./src/utils/analytics/analytics.js